import { combineReducers } from 'redux';

import registrationUiReducer from './registrationUiReducer';
import registrationDataReducer from './registrationDataReducer';

export default combineReducers({
  ui: registrationUiReducer,
  data: registrationDataReducer,
});
